import { ChangeEvent, FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

// eslint-disable-next-line no-unused-vars
type StringSetter = (value: string) => void;

type AnalyticsFiltersProps = {
  fromDate: string;
  toDate: string;
  partnerSearch: string;
  onChangeFromDate: StringSetter;
  onChangeToDate: StringSetter;
  onChangePartnerSearch: StringSetter;
};

const AnalyticsFilters: FC<AnalyticsFiltersProps> = ({
  fromDate,
  toDate,
  partnerSearch,
  onChangeFromDate,
  onChangeToDate,
  onChangePartnerSearch,
}) => {
  const { t } = useTranslate();

  const handleDateChange =
    (setter: StringSetter) => (event: ChangeEvent<HTMLInputElement>) => {
      setter(event.target.value);
    };

  const handlePartnerSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChangePartnerSearch(event.target.value);
  };

  return (
    <div className="row align-items-end mb-3">
      <div className="col-md-3">
        <label className="form-label" htmlFor="analytics-from-date">
          {t('FilterFromDate')}
        </label>
        <input
          id="analytics-from-date"
          data-testid="analytics-from-date"
          type="date"
          className="form-control"
          value={fromDate}
          onChange={handleDateChange(onChangeFromDate)}
        />
      </div>
      <div className="col-md-3">
        <label className="form-label" htmlFor="analytics-to-date">
          {t('FilterToDate')}
        </label>
        <input
          id="analytics-to-date"
          data-testid="analytics-to-date"
          type="date"
          className="form-control"
          value={toDate}
          onChange={handleDateChange(onChangeToDate)}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label" htmlFor="analytics-partner-search">
          {t('ColumnPartner')}
        </label>
        <input
          id="analytics-partner-search"
          data-testid="analytics-partner-search"
          type="search"
          className="form-control"
          value={partnerSearch}
          onChange={handlePartnerSearchChange}
          placeholder={t('FilterPartnerSearchPlaceholder')}
          aria-label={t('FilterPartnerSearchPlaceholder')}
        />
      </div>
    </div>
  );
};

export default AnalyticsFilters;
